import React  from 'react';
import { Box, Radio, RadioGroup, FormControlLabel, Typography } from '@material-ui/core';

const keyLabelMap = {
  isPscVisible: 'Profile Scorecard',
  isCareerVisible: 'Career',
  isRankingVisible: 'Ranking',
  isQscVisible: 'Qualification Scorecard'
};

const UserGroupVisibleSections = ({ menu = {}, onChange }) => {
  const handleChange = (key) => (event) => {
    const next = {
      ...menu,
      [key]: event.target.value === 'true'
    };

    if (typeof onChange === 'function') {
      onChange(next);
    }
  };

  return (
    <div>
      <div className="input-group-prepend">Visible Sections:</div>

      <div style={{ marginTop: 8 }}>
        {Object.keys(keyLabelMap).map((key) => (
          <Box key={key} display="flex" alignItems="center" mb={1}>
            <Typography style={{ minWidth: 200 }}>
              {keyLabelMap[key]}:
            </Typography>

            <RadioGroup
              row
              name={key}
              value={menu[key] ? 'true' : 'false'}
              onChange={handleChange(key)}
            >
              <FormControlLabel value="true" control={<Radio />} label="true" />
              <FormControlLabel value="false" control={<Radio />} label="false" />
            </RadioGroup>
          </Box>
        ))}
      </div>
    </div>
  );
};


export default UserGroupVisibleSections;
